import { SERVICE_STATUSES } from '../../constants';

export type CompletedJobLogStatusChoice = 'Completed' | 'Admin Review';

/**
 * Derives `event.logJobStatus` when the user records a Completed step on the Services tab.
 *
 * - On Call → Completed: job goes to Admin Review for back-office follow-up.
 * - Admin → Completed: job is finished from the admin workflow; set to Completed unless overridden.
 * - ServiceCallAdmin dialog: explicit `forceLogJobStatus` wins.
 */
export function getCompletedJobStatus(params: {
  forceLogJobStatus?: CompletedJobLogStatusChoice;
  lastStatus: string;
}): string {
  const { forceLogJobStatus, lastStatus } = params;
  if (forceLogJobStatus === 'Completed') return 'Completed';
  if (forceLogJobStatus === 'Admin Review') return 'Admin Review';
  if (lastStatus === SERVICE_STATUSES.ADMIN) return 'Completed';
  return 'Admin Review';
}
